
import React from 'react';
import { motion } from 'framer-motion';

interface FeatureBadgeProps {
  icon: React.ReactNode;
  text: string;
}

export function FeatureBadge({ icon, text }: FeatureBadgeProps) {
  return (
    <motion.div 
      whileHover={{ scale: 1.05 }}
      className="inline-flex items-center rounded-full bg-sky-50 border border-sky-200 px-2.5 py-1.5 text-xs md:text-sm shadow-sm"
    >
      <span className="text-sky-600 mr-1.5">{icon}</span>
      <span className="text-sky-700 font-medium">{text}</span>
    </motion.div>
  );
}
